import {createRouter as _createRouter, createWebHistory} from 'vue-router'

const Home = () => import('../pages/Home');
const ChangePassword = () => import('../pages/ChangePassword');
const welcome = () => import('../pages/welcome');
export function createRouter () {
  return _createRouter({
    history: createWebHistory(),
    routes: [
      {
        path: '/OktaSpaRegistration/',
        name: 'Home',
        component: Home
      },
      {
        path: '/OktaSpaRegistration/register',
        name: 'Register',
        component: Home
      },
      {
        path: '/OktaSpaRegistration/2ndProducer',
        name: '2ndProducer',
        component: () => import('../pages/SecondProducer.vue')
      },
      {
        path: '/OktaSpaRegistration/producerassistant/create',
        name: 'producerassistantcreate',
        component: () => import('../pages/ProducerAssistantCreate.vue')
      },
      {
        path: '/OktaSpaRegistration/producerassistant/add',
        name: 'producerassistantadd',
        component: () => import('../pages/ProducerAssistantAdd.vue')
      },
      {
        path: '/OktaSpaRegistration/ChangePassword/',
        name: 'ChangePassword',
        props:true,
        component: ChangePassword
      },
      {
        path: '/OktaSpaRegistration/home/',
        name: 'welcome',
        component: welcome
      },
    ]
  });
}
